var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/reply-indicator.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import AttachmentThumbs from 'soapbox/components/attachment-thumbs';
import { Stack, Text } from 'soapbox/components/ui';
import AccountContainer from 'soapbox/containers/account-container';
import { isRtl } from 'soapbox/rtl';

const ReplyIndicator = _ref => {
  let {
    status,
    hideActions,
    onCancel
  } = _ref;

  const handleClick = () => {
    onCancel();
  };

  if (!status) {
    return null;
  }

  let actions = {};

  if (!hideActions && onCancel) {
    actions = {
      onActionClick: handleClick,
      actionIcon: require('@tabler/icons/x.svg'),
      actionAlignment: 'top',
      actionTitle: 'Dismiss'
    };
  }

  return /*#__PURE__*/React.createElement(Stack, {
    space: 2,
    className: "p-4 rounded-lg bg-gray-100 dark:bg-gray-800",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(AccountContainer, _extends({}, actions, {
    id: status.getIn(['account', 'id']),
    timestamp: status.created_at,
    showProfileHoverCard: false,
    withLinkToProfile: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(Text, {
    className: "break-words status__content",
    size: "sm",
    dangerouslySetInnerHTML: {
      __html: status.contentHtml
    },
    direction: isRtl(status.search_index) ? 'rtl' : 'ltr',
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 45,
      columnNumber: 7
    }
  }), status.media_attachments.size > 0 && /*#__PURE__*/React.createElement(AttachmentThumbs, {
    media: status.media_attachments,
    sensitive: status.sensitive,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 9
    }
  }));
};

export default ReplyIndicator;